import React from "react";
import { motion } from "framer-motion";
import ResumeCard from "./ResumeCard";

const Education = () => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1, transition: { duration: 0.5 } }}
      className="w-full flex flex-col lgl:flex-row gap-10 lgl:gap-20"
    >
      {/* part one */}
      <div>
        <div className="py-6 lgl:py-12 font-titleFont flex flex-col gap-4">
          <p className="text-sm text-designColor tracking-[4px]"></p>
          <h2 className="text-3xl md:text-4xl font-bold">Education Quality</h2>
        </div>
        <div className="mt-6 lgl:mt-14 w-full h-[1000px] border-l-[6px] border-l-black border-opacity-30 flex flex-col gap-10">
          <ResumeCard
            title="MIT Computer Science"
            subTitle="University of Lagos"
            result="Distinction"
            des="The program is aimed at training professionals in business management with a focus on ICT."
          />
          <ResumeCard
            title="Bsc Computer Science"
            subTitle="University of Ibadan"
            result="UpperClass"
            des="Higher education is tertiary education leading to award of an academic degree. Higher education, also called post-secondary education."
          />
          <ResumeCard
            title="Senior Secondary School"
            subTitle="IGBOBI COLLEGE,YABA,LAGOS"
            result="8Credits"
            des="Secondary education or post-primary education covers two phases on the International Standard Classification of Education scale."
          />
        </div>
      </div>
      {/* part Two */}

      <div>
        <div className="py-6 lgl:py-12 font-titleFont flex flex-col gap-4">
          <p className="text-sm text-designColor tracking-[4px]"></p>
          <h2 className="text-3xl md:text-4xl font-bold">Job Experience</h2>
        </div>
        <div className="mt-6 lgl:mt-14 w-full h-[1000px] border-l-[6px] border-l-black border-opacity-30 flex flex-col gap-10">
          <ResumeCard
            title="Frontend Web Developer"
            subTitle="MENTAPPS SOLUTIONS - (2013 - 2016)"
            result="Ikeja"
            des="Responsible for creating all aspects of clients website, from start to finish."
          />
          <ResumeCard
            title="Web Developer"
            subTitle="Opera ADS - (2016 - 2019)"
            result="Opebi"
            des="Lead web designer."
          />
          <ResumeCard
            title="Front-end Developer"
            subTitle="Global Buy - (2019 - Present)"
            result="Ikeja"
            des=" Ensure website functionality and stability across devices. Design engaging landing pages. Manage and Maintain the company's website."
          />
        </div>
      </div>
    </motion.div>
  );
};

export default Education;
